/**
 * @param {Phaser.Scene} scene
 */
export const createTitle = (scene, width, height, text, scaleX) => {
  const titleText = scene.add
    .text(width, height / 3, text, {
      fontFamily: "Grooving",
      fontSize: "70px",
      color: "white",
    })
    .setScale(scaleX);
  const title = scene.physics.add.existing(titleText, false);
  title.body.setVelocityX(-1000 * scaleX);
  return title;
};

/**
 * @param {Phaser.Physics.Arcade.Sprite} title
 */
export const updateTitle = (title, scaleX) => {
  if (title.x < -100) {
    title.destroy(true);
  } else {
    if (title.x < 650) {
      title.body.setVelocityX(-450 * scaleX);
    }
    if (title.x < 350) {
      title.body.setVelocityX(-1000 * scaleX);
    }
  }
};
